import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Livraison, BoisType, LongueursAchat, Achat, EssenceAchat} from '@/models';
import {LivraisonService} from "@/xhttp";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class LivraisonFilter {	date: DateFilter = new DateFilter();

	boisType: BoisType[] = [];
	longueursAchat: LongueursAchat[] = [];
	destination: string = '';
	totalParDepot: boolean = false;
	totalParBoisType: boolean = false;
	totalParLongueur: boolean = false;
	totalDateDebut: string = '';
	totalDateFin: string = '';

	public clear(): void {
		this.date = new DateFilter();
		this.boisType = [];
		this.longueursAchat = [];
		this.destination = '';
		this.totalParDepot = true;
		this.totalParBoisType = true;
		this.totalParLongueur = true;
		this.totalDateDebut = '';
		this.totalDateFin = '';
	}

	public toString(): string {
		return JSON.stringify({
			date	: this.date,
			boisType    : this.boisType.map(t => t.id),
			longueursAchat    : this.longueursAchat.map(t => t.id),
			destination	:	this.destination,
			totalParDepot	: this.totalParDepot,
			totalParBoisType	: this.totalParBoisType,
			totalParLongueur	: this.totalParLongueur,
			totalDateDebut	:	this.totalDateDebut,
			totalDateFin	:	this.totalDateFin,
		});

	}
}

class LivraisonState extends PaginatorFilterState<LivraisonFilter> {
	livraison: Livraison = null;
	livraisons: ResultType<Livraison> = null;
	public constructor() {
		super(new LivraisonFilter(), 'livraisons', 'livraison', 'id', AscDesc.DESC, 20)
	}
}

class LivraisonStore {

	@XHTTPService(() => Livraison)
	private livraisonService: LivraisonService;
	private  _store: Store<any>;

	public state: LivraisonState = new LivraisonState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'livraisons', 'livraison'),
	};

	public actions = {
		...StandardAction<Livraison, LivraisonState>(() => Livraison, 'livraison'),
		...PaginatorActionWithFilters<Livraison, LivraisonState>(() => Livraison, 'livraisons', 'livraison'),

		async getTotauxLivraisons(context: ActionContext<LivraisonState, any>): Promise<ResultType<Livraison>> {
			const livraisonsTotauxResult = await instance.livraisonService.getTotauxLivraisons(storeLivraisonsTotaux.state.filters.totalParDepot, storeLivraisonsTotaux.state.filters.totalParBoisType, storeLivraisonsTotaux.state.filters.totalParLongueur, storeLivraisonsTotaux.state.filters.totalDateDebut, storeLivraisonsTotaux.state.filters.totalDateFin);
			context.commit('setLivraisons', livraisonsTotauxResult);
			return livraisonsTotauxResult;
		},
		async putPaid(context: ActionContext<LivraisonState, any>, livraison: Livraison) {
			return await instance.livraisonService.putPaid(livraison);
		},
		async putFacture(context: ActionContext<LivraisonState, any>, livraison: Livraison) {
			return await instance.livraisonService.putFacture(livraison);
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new LivraisonStore();
const storeLivraison = new Vuex.Store(instance);
instance.init(storeLivraison);

const instanceTotaux = new LivraisonStore();
export const storeLivraisonsTotaux = new Vuex.Store(instanceTotaux);
instanceTotaux.init(storeLivraisonsTotaux);

store.registerModule('livraison', storeLivraison);
store.registerModule('livraisonsTotaux', storeLivraisonsTotaux);
export default storeLivraison;